import { render } from "./ShippingFormInitializer.vue?vue&type=template&id=53be5e97"
import script from "./ShippingFormInitializer.vue?vue&type=script&setup=true&lang=js"
export * from "./ShippingFormInitializer.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/ShippingFormInitializer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53be5e97"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53be5e97', __exports__)) {
    api.reload('53be5e97', __exports__)
  }
  
  module.hot.accept("./ShippingFormInitializer.vue?vue&type=template&id=53be5e97", () => {
    api.rerender('53be5e97', render)
  })

}


export default __exports__